import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as filterCounter from './scripts/filter-counter';
filterCounter.init();

import * as locationMap from './scripts/location-map';
locationMap.init();